import * as React from 'react';

import {
  IDeveloperCell,
  IInfrastructureCell,
  ILinkCell,
  INewbuildingSummaryCell,
  IRoomStatsCell,
  ITextCell,
  ITextListCell,
  ITransportPointExtendedCell,
  TNewbuildingsCompareCell,
  TNewbuildingsCompareRow,
} from '../../../../types/newbuildingsCompare';
import {
  DeveloperCell,
  InfrastructureCell,
  LinkCell,
  NewbuildingSummaryCell,
  NewbuildingSummaryCellFloating,
  RoomStatsCell,
  TextCell,
  TextListCell,
  TransportPointExtendedCell,
} from './cells';

export interface ICellProps {
  type: TNewbuildingsCompareRow['type'];
  cell: TNewbuildingsCompareCell;
  floating?: boolean;
}

export const Cell = ({ type, cell, floating }: ICellProps): React.JSX.Element | null => {
  switch (type) {
    case 'text':
      return <TextCell cell={cell as ITextCell} />;

    case 'link':
      return <LinkCell cell={cell as ILinkCell} />;

    case 'textList':
      return <TextListCell cell={cell as ITextListCell} />;

    case 'developer':
      return <DeveloperCell cell={cell as IDeveloperCell} />;

    case 'roomStats':
      return <RoomStatsCell cell={cell as IRoomStatsCell} />;

    case 'infrastructure':
      return <InfrastructureCell cell={cell as IInfrastructureCell} />;

    case 'transportPointExtended':
      return <TransportPointExtendedCell cell={cell as ITransportPointExtendedCell} />;

    case 'newbuildingSummary':
      return floating ? (
        <NewbuildingSummaryCellFloating cell={cell as INewbuildingSummaryCell} />
      ) : (
        <NewbuildingSummaryCell cell={cell as INewbuildingSummaryCell} />
      );

    default:
      return null;
  }
};
